export const emptyQueueObject = {
  agentDetails: {},
  agentsIds: [],
  scope: "",
  language: "en-US",
  huntMethod: "roundRobin",
  maxAlertTime: 40,
  maxInQueue: 30,
  announcePositionInQueue: false,
  announceEstimatedWaitTime: false,
  keepAgentOnRequeue: false,
  fallbackIfNoAgentConnected: false,
  enableVipPriority:false,
  vipIds:[],
  vipDetails:{},
  queueFallBackMessage: {
    enabled: false,
    fileName: "",
    type: "",
    language: "en-US",
    text: "",
    audioFileUrl: "",
  },
  authorizedActivityValues: ["Available"],
  waitTimeIntervals: ["1", "3", "5"],
  sla: 60,
  wrapUpTime: 0,
  slaThreshold: 50,
  tasks: {},
  calls: {},
  musicOnHold: [
    {
      header: "default-moh",
      url: "https://callcenterconf.blob.core.windows.net/heedifymedia/defaultMoH/default-Heedify-Moh.wav",
    },
  ],
  queueName: "",
  queueOverflow: {
    displayName: "",
    type: "disconnect",
    targetType: "user",
    targetId: "",
    queueId: "",
    queueDisplayName: "",
  },
  maxWaitTime: 1200,
  integrationParams: {
    servicetype: "none",
    serviceURL: "",
    method: "POST",
    headers: {}
  },
  closeCRMPopUpOn: "CALL_RING_END",
  defaultReasonCode: "",
  // `READY` en tête : c'est l'activité qui remet l'agent en réception d'appels. Sans elle dans
  // le catalogue, une file neuve ne proposait que des motifs d'indisponibilité — l'agent pouvait
  // se déclarer en pause mais pas redevenir disponible depuis la liste d'activités.
  reasonCodes: [
    "READY",
    "COFFEE_BREAK",
    "ADMIN WORK",
    "OUT OF SHIFT",
    "UNAVAILABLE"
  ],
  channels: { call: true },
};
